import React, { useEffect, useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import Snapshot from "./ApplicantDetail/Snapshot";
import PersonalDetails from "./ApplicantDetail/PersonalDetails";
import ProfessionDetails from "./ApplicantDetail/ProfessionDetails";
import EmployerDetails from "./ApplicantDetail/EmployerDetails";
import EmploymentTestResults from "./ApplicantDetail/EmploymentTestResults";
import Activities from "./ApplicantDetail/Activities";
import ApplicantsDetailsDrawer from "../../Modal/ApplicantsDetailsDrawer";
import Submission from "./ApplicantDetail/Submission";
import {
  AdvSeparator,
  Backdrop,
  Button,
  CopyToClipboard,
  DualIcon,
  InfoTextAdv,
  LogoLoader,
  NewTab,
  PageHeader,
  PageTab,
  PageTitle,
  SmartTooltip,
  StatusTags,
} from "../../../../../../components";
import { useModuleAccess } from "../../../../../../hooks";
import { getApplicant } from "../../../../../../redux/slices/recruitmentSourcing/SourcingApi";
import AddApplicantModal from "../Modals/AddApplicantModal";
import ApplicantSubmitJobModal from "../../Modal/ApplicantDetailsModals/ApplicantSubmitJobModal";
import { formatPhoneNumberLength, formatWords2 } from "../../../../../../utils/stringUtils";

// const sourceOptions = {
//   1: "Internal",
//   2: "Career Builder",
//   3: "Monster",
// };
const sourceOptions = {
  1: "Internal DB",
  2: "Career Builder",
  3: "Monster",
  4: "Career Portal",
  5: "CareerJet",
  6: "Dice",
  7: "Glassdoor",
  8: "Indeed",
  9: "LinkedIn",
  10: "Naukari",
  11: "Neuvoo",
  12: "Post Job Free",
  13: "Snaprecruit",
  14: "Stack Overflow",
  15: "ZipRecruiter",
  16: "Employee Referral",
  17: "Employment Agency",
  18: "Gmail",
  19: "Job Fair",
  20: "Others",
  21: "Outlook",
  22: "Passive Sourcing",
  23: "Resume Inbox"
};

const ApplicantDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { applicantId } = location.state || "";
  const { source, selectedJobUiid } = location.state || "";
  const [applicantDetails, setApplicantDetails] = useState();
  const [submitJobModal, setSubmitJobModal] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [advSepData, setAdvSepData] = useState({
    "Job Title": "",
    location: "",
    "Primary Mobile Number": "",
    "Home Mobile Number": "",
    "Primary Email Address": "",
    Source: "",
    "Work Authorization": "",
  });
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [loading, setLoading] = useState(false);

  const ApplicantTabMenus = [
    {
      title: "Snapshot",
      page: <Snapshot data={applicantDetails} />,
      type: "main",
      id: "applicantid_snapshot",
    },

    {
      title: "Personal Details",
      page: <PersonalDetails data={applicantDetails} />,
      type: "main",
      id: "applicantid_personaldetails",
    },
    {
      title: "Profession Details",
      page: <ProfessionDetails data={applicantDetails} />,
      type: "main",
      id: "applicantid_professionaldetails",
    },
    {
      title: "Employer Details",
      page: <EmployerDetails />,
      type: "main",
      id: "applicantid_employerdetails",
    },
    {
      title: "Employment Test Results",
      page: <EmploymentTestResults />,
      type: "main",
      id: "applicantid_employmenttestresults",
    },
    {
      title: "Activities",
      page: <Activities data={applicantDetails} />,
      type: "main",
      id: "applicantid_activities",
    },
    {
      title: "Submission",
      page: <Submission data={applicantDetails} />,
      type: "main",
      id: "applicantid_submission",
    }
  ];

  const whatsappIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="WhatsApp"
    >
      <title>WhatsApp</title>

      <path
        fill="#25D366"
        d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 .02 5.35.02 12c0 2.11.55 4.08 1.6 5.83L0 24l6.42-1.68A11.94 11.94 0 0 0 12 24c6.63 0 12-5.35 12-12 0-3.2-1.25-6.2-3.48-8.32z"
      />

      <path
        fill="#FFFFFF"
        d="M17.56 14.01c-.3-.15-1.76-.86-2.03-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.95 1.15-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.48-.9-.8-1.51-1.78-1.69-2.08-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.48.1-.2.05-.37-.03-.52-.08-.15-.67-1.6-.92-2.19-.24-.57-.48-.49-.66-.5l-.56-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.48 1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.48 2.98 1.29 2.98.86 3.52.81.54-.05 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.08-.13-.27-.2-.57-.35z"
      />
    </svg>
  );
  const filteredTabs = useModuleAccess({
    allTabs: ApplicantTabMenus,
    parentId: "applicantid",
  });

  const fetchApplicantDetails = async () => {
    setLoading(true);

    const response = await getApplicant({
      coll: "Candidate",
      fil: JSON.stringify({ uiid: { type: "NONE", value: applicantId } }),
      ref: "Note Resume",
      extret: "uiid firstName lastName role",
    });

    if (response?.success) {
      setApplicantDetails(response.data.data);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchApplicantDetails();
  }, [applicantId]);

  useEffect(() => {
    if (isEditOpen == false) {
      if (source == "bdm-alljobs-edit" || source == "draftJobs-edit" || source == "recruit-alljobs-edit" || source == "recruit-myjobs-edit") {
        setIsEditOpen(true)
      }
    }
  }, []);

  useEffect(() => {
    if (applicantDetails) {
      setAdvSepData({
        "Job Title": formatWords2(applicantDetails?.jobTitle),
        // location: `${applicantDetails.location?.city}, ${applicantDetails.location?.state?.code}, ${applicantDetails.location?.country?.code}, ${applicantDetails.location?.zipCode}`,
        location: [
          applicantDetails.location?.city,
          applicantDetails.location?.state,
          applicantDetails.location?.country,
          applicantDetails.location?.zipCode
        ].filter(Boolean).join(", "),
        "Primary Mobile Number":
          applicantDetails?.mobile?.primary?.number
            ? `${applicantDetails?.mobile?.primary?.code || ""} ${formatPhoneNumberLength(applicantDetails?.mobile?.primary?.code, applicantDetails?.mobile?.primary?.number)}`
            : "",
        "Home Mobile Number": "--",
        "Primary Email Address": applicantDetails?.email?.primary?.email,
        Source: sourceOptions[applicantDetails?.source],
        "Work Authorization": applicantDetails?.workAuth || "--",
      });
    }
  }, [applicantDetails]);

  return (
    <>
      <div className="flex flex-col gap-2 flex-1 max-h-screen">
        <Button
          title="Applicant Details"
          color="black"
          variant="text"
          size="xl"
          fromLeft
          icon="arrow_left_alt"
          className="text-lg self-start font-semibold"
          onClick={() => {
            // console.log("back button clicked", source);
            if (source == "bdm-alljobs" || source == "bdm-alljobs-edit") {
              navigate(-1);
            } else if (source == "draftJobs" || source == "draftJobs-edit") {
              navigate("/ats/jobs");
              //navigate("/ats/jobs/jobs_draftjobs")
            }
            else if (source == "recruit-alljobs" || source == "recruit-alljobs-edit") {
              navigate("/ats/recruitment/jobs");
            }
            else if (source == "recruit-myjobs" || source == "recruit-myjobs-edit") {
              navigate(-1);
            } else if (source == "/ats/jobs/job-details?job-details=submission") {
              navigate(-1);
            } else if (source === "kult-ai-calls") {
              navigate(-1);
              sessionStorage.setItem("selectedJobUiid", selectedJobUiid);
            } else if (source == "/ats/jobs/job-details?job-details=talent-match") {
              navigate(-1);
              sessionStorage.setItem("selectedJobUiid", selectedJobUiid);
            } else {
              navigate("/ats/applicants");
            }
          }}
        />
        <div className="shadow-md !bg-[#fffcfa] rounded-lg p-3 mx-3 my-1">
          <PageHeader
            Section={
              <div className="flex items-center gap-4">
                <div className="flex flex-col items-start">
                  <div className="text-primary mb-0.5">
                    <PageTitle
                      title={`${formatWords2(applicantDetails?.firstName)} ${formatWords2(applicantDetails?.lastName)}`}
                      tag="h6"
                    />
                  </div>
                  <div className="text-gray-400 font-[500] text-xs">
                    <PageTitle title={formatWords2(applicantDetails?.jobTitle)} tag="p" />
                  </div>
                </div>
                <StatusTags icon />
              </div>
            }
            RightSection={
              <div className="flex gap-1 items-center">
                <SmartTooltip description={"View Resume"} noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    onClick={() => {
                      setDetailsDrawer(true);
                    }}
                    size="sm"
                    icon={"visibility"}
                  />
                </SmartTooltip>
                <SmartTooltip description={"Edit"} noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    size="sm"
                    icon={"edit_square"}
                    onClick={() => setIsEditOpen(true)}
                  />
                </SmartTooltip>
                <SmartTooltip description={"Phone"} noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    size="sm"
                    icon={"phone_in_talk"}
                  />
                </SmartTooltip>
                <SmartTooltip description={"Text"} noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    size="sm"
                    icon={"chat"}
                  />
                </SmartTooltip>
                <SmartTooltip description={"Whatsapp"} noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    icon={whatsappIcon}
                  />
                </SmartTooltip>
                <SmartTooltip
                  description={"Submit Job"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  {applicantDetails && (
                    <DualIcon
                      size="xs"
                      icon="article"
                      badgeIcon="visibility"
                      iconColor="black"
                      dotPosition="bottom-right"
                      badgeIconColor="text-black"
                      onClick={() => setSubmitJobModal(true)}
                    />
                  )}
                </SmartTooltip>
              </div>
            }
          />
          <div className="px-8 inner-section shadow-xl rounded-lg py-5 flex my-3">
            <div className="flex flex-1 w-full">
              <AdvSeparator gap="gap-6" className="gap-y-6 overflow-hidden">
                {Object.keys(advSepData).map((key, index) => {
                  return (
                    <>
                      <InfoTextAdv
                        key={index}
                        title={key}
                        titleProps={{ className: "!text-black" }}
                        value={
                          <div className="w-full">
                            <div className=" text-black font-medium">
                              {key === "Primary Email Address" ? (
                                <div className={"flex items-center gap-0.5 "}>
                                  <h6 className="line-clamp-1">
                                    {advSepData[key]}
                                  </h6>
                                  <CopyToClipboard
                                    title={advSepData[key]}
                                    content={advSepData[key]}
                                    color={"info"}
                                  />
                                </div>
                              ) : (
                                <h6 className="line-clamp-1">
                                  {advSepData[key]}
                                </h6>
                              )}
                            </div>
                          </div>
                        }
                      />
                    </>
                  );
                })}
              </AdvSeparator>
            </div>
          </div>
        </div>
        <div className="flex-1 flex flex-col overflow-hidden">
          <NewTab
            tabs={filteredTabs}
            color="gray"
            variant="text"
            activeVariant="text"
          />
        </div>
      </div>
      <AddApplicantModal
        isOpen={isEditOpen}
        onClose={() => {
          setIsEditOpen(false);
        }}
        source={source}
        edit={true}
        applicantId={applicantDetails?.uiid}
      />
      <ApplicantsDetailsDrawer
        isOpen={detailsDrawer}
        onClose={() => setDetailsDrawer(false)}
        applicantId={applicantDetails?.uiid}
      />
      <ApplicantSubmitJobModal
        isOpen={submitJobModal}
        onClose={() => setSubmitJobModal(false)}
        applicant={applicantDetails}
      />

      <Backdrop isOpen={loading} zIndex={54}>
        <LogoLoader />
      </Backdrop>
    </>
  );
};

export default ApplicantDetails;
